<template>
  <DialogDescription
    data-slot="dialog-description"
    v-bind="forwardedProps"
    :class="cn('tw:text-muted-foreground tw:type-body', props.class)"
  >
    <slot />
  </DialogDescription>
</template>

<script setup>
import { reactiveOmit } from '@vueuse/core';
import { cn } from '@/shared/utilities/classes';
import { DialogDescription, useForwardProps } from 'reka-ui';

const props = defineProps({
  asChild: { default: undefined, type: Boolean, required: false },
  as: { default: undefined, type: null, required: false },
  class: {
    default: undefined,
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>
